import { memo } from 'react';
import cn from 'classnames';
import { useSupportChat } from './SupportChatContext';
import styles from './SupportChatButton.module.css';

interface SupportChatButtonProps {
    isFixed?: boolean;
}

export const SupportChatButton = memo(function SupportChatButton(props: SupportChatButtonProps) {
    const { isFixed = false } = props;
    const { registerMountTarget } = useSupportChat();

    return <div ref={registerMountTarget} className={cn(styles.root, { [styles.fixed]: isFixed })} />;
});
